<template>
    <div>
        <div id="all">
            <div id="plate">
                <div id="logoHolder">
                    <div id="amCircle" :style="{'background-image':'url(' + require('@/assets/artmuseo.svg')+')'}"></div>
                    <div id="amBand" :style="{'background-image':'url(' + require('@/assets/artmuseo_bandlogo_reg.svg')+')'}"></div>
                </div>
                <div id="arteverywhere" class="band bgWhiteSmoke" :style="{'background-image':'url(' + require('@/assets/images/rmp.png')+')'}">
                    <div id="leftholder">
                    <div id="arteverywhere" class="splash amTeal textcenter">Get Started</div>
                    <div id="textbox" class="lighttext amGray textcenter">A brand new platform requires new ways of interaction. Here are some frequently asked questions about how to use Artmuseo on your phone and your computers.
                    </div>
                    </div>
                        <div id="imgright" class="imageBox" :style="{'background-image':'url(' + require('@/assets/images/phone01.png')+')'}"></div>
                </div>
                <div id="mission" class="band bgTeal">
                    <div id="oneholder">
                        <div id="titler" class="splash amWhite textcenter">FAQ<br><br></div>
                        <div id="textbox2" class="regtext amWhite textleft">
                            <div class="amBOLDTitle"><b>What is the ‘Art Museo’ Feed?</b></div>
The first view you see when you log in is ‘Art Museo’. Think of it as the museum gallery where all the works are displayed.

You will see only artworks on this view; only displaying the artwork image, title, and year. To learn more about the selected artwork, tap on the image to see the detail view.
          <br><br>
<div class="amBOLDTitle"><b>What is ‘The Salon’ Feed?</b></div>
The Salon is where curators and artists you follow display art and interact with each other. Learn about how others live an artful life.
<br><br>
<div class="amBOLDTitle"><b>How can I post?</b></div>
On iOS, If you are on the Art Museo Tab (Teal top bar with ARTMUSEO text), tap the circle logo to the left. The view will switch to Salon. Next to the word Salon is a circle logo with a plus sign (+) Tap it and a box will open with options to Contribute.
Tap each option to learn more about all the things you can share on the platform.<br><br>
On Desktop or Mobile Browsers, click to Salon Tab and next to the word Salon, you'll find the circle logo with a plus (+) Tap it to see options.
<br>
<br>
<div class="amBOLDTitle"><b>What is Curate?</b></div>
When you find an artwork you absolutely love, clock the curate button to share it to your followers. This will add the artists' work to your collection defining your curatorial expressions. Don’t forget to say something evocative about your curation.
<br><br>
<div class="amBOLDTitle"><b>What kind of photos can I share in Art Life?</b></div>
Art Life Posts can vary in many ways. You can use it to post sketch drawings or works in progress, photos of you interacting with artwork, at a museum or gallery opening, or simply pictures of other artworks you like (just mention the artist in the caption). You can post anything with Art Life as long as your post encourages an artful conversation.
<br><br>
<div class="amBOLDTitle"><b>How do I search for Users?</b></div>
On The Salon tab, you will find the magnifying glass icon on the top right. When the view pops up, type in a search keyword and press the magnifying glass icon. A list of users will be presented. A stands for Artists and C stands for Curators.
<br><br>
<div class="amBOLDTitle"><b>How do I share or edit a post?</b></div>
When browsing the Art Museo Feed and the Salon Feed, tap a specific post. Locate the ellipsis icon (3 dots) on iOS (Top right above the image) on Desktop (right of image, next to post Username and User Image). Tap the three dots. There you can share a “web link” to those not in the app so they may view the post on their browsers, or “share post” as a message to another user in Art Museo. If the post belongs to you, you can tap Edit Post to change your caption or delete the post.
<br><br>
<div class="amBOLDTitle"><b>How do I chat with other users?</b></div>
On Desktop or Mobile browsers, go to the Account Tab (Your User Settings with your profile photo). Tap the chat bubble on the top bar and a view will be presented. Tap compose to start a conversation. Only people who follow you will show up on the list. All conversations need to be accepted by the recipient.
On iOS, navigate to the view where the tab bar icons on the bottom are located. Last icon is a chat bubble.
<br><br>
Remember to stay safe! Never share sensitive information in chat with other users.
<br>
Alternatively, you can also find the user’s profile and tap the chat icon to the right of their profile image.
<br><br>
<div class="amBOLDTitle"><b>How do I view a user’s profile?</b></div>
Simply click the username or profile photo wherever you see it and it will bring you to their profile. If you know the username, you can type this directly on the search tab available in the Salon.
<br><br>
<div class="amBOLDTitle"><b>How do I report a post?</b></div>
Find the post you want to report, and then click the three periods and tap “Report Post”. Choose a reason, and add a note. We review all reported posts and take proper action. Read our content guidelines to learn more about post moderation rules.
<br><br>
<div class="amBOLDTitle"><b>What is a Public Art Post?</b></div>
Public Art Post is ideal for Murals and Art Installations, be it an art performance you witnessed or a sculpture you walked by. You can turn on this feature from posting ArtLife. Toggle "Public Art" and we'll include a general location with the post. Available on iOS only.
<br>
<br>
<div class="amBOLDTitle"><b>What is AR (Augmented Reality)?</b></div>
AR or Augmented Reality is a feature that allows users to display artworks in virtual space like VR, or in their own environment. When you are viewing an artwork from the Museo Feed, you may come across the AR Button. Tap it and try out "Art Show" to get transported to a white wall gallery from your phone. You will see the artwork against the wall. You can also do the Home Display option which will try to locate a vertical space from your phone's camera view and automatically place the artwork you have clicked on, in its actual "real life" dimensions.
<br>
<br>
<div class="amBOLDTitle"><b>What is Art Scene and Art Market?</b></div>
Artmuseo is not just a platform for sharing artworks with friends, it is also a hub for Art Events, Museum Exhibition Listings, Art Articles and more. Though presently, with COVID-19 affecting our daily lives, the ArtScene tab does not list any events. Articles will start trickling in as we go along with BETA. The Art Market is our marketplace where users can invest in Art buy purchasing new works and adding it to their collections. Artists with seller priveleges, along with Galleries and Art Organizations can also list works here for sale. The Art Market is in the final phases of building, so be sure to check in often.
<br>
<br>
<div class="amBOLDTitle"><b>Do you have a question?</b></div>
Send us your questions via the BETA FEEDBACK form. Thank you for reading! Stay Creative!
<br>
<br>
                        </div>
                    </div>
                </div>
                <div id="footer">
                    <div id="leftholder">
                        <div class="logobox" :style="{'background-image':'url(' + require('@/assets/artmuseo_box.svg')+')'}" ></div>
                        <div id="disclaim" class="smalltext amWhite textcenter">Artmuseo is a trademark of Art Museo, Inc. All Rights Reserved ©2019-2020.<br><br></div>
                    </div>
                    <div id="rightholder">
                        <div class="blank"></div>
                        <div id="signin" class="amWhite textcenter cpointer"><a v-bind:href="artmuseoapp" target="_blank"><span class="amWhite">Artmuseo WebApp</span></a></div>
                        <!-- <div id="signin" class="amWhite textcenter">Investment Inquiries</div> -->
                        <!-- <div id="signin" class="amWhite textcenter">Join our Team | Opportunities</div> -->
                        <div id="signin" class="amWhite textcenter cpointer"><a v-bind:href="policy" target="_blank"><span class="amWhite">Platform Terms & Policies</span></a></div>
                        <!-- <div id="add" class="amWhite textcenter">577 Ofarrell Street | San Francisco CA</div> -->
                        <!-- <div id="signin" class="amWhite textcenter">Contact Us</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import db from '../main'
export default {
    name: "faq",
    metaInfo: {
    title: "Artmuseo | Curate an artful life",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale = 1.0,maximum-scale = 1.0, viewport-fit=cover, user-scalable=no", zoom: "fixed"},
      { charset: 'utf8'},
      { property:"og:image", content: "<%= BASE_URL %>ammetaimg.png" },
      { title: 'Artmuseo | Curate an Artful Life' }
    ]
  },
    data(){
        return {
            email: "",
            fullname: "",
            type: "",
            ifSent: false,
            artmuseoapp: 'https://artmuseo.com',
            policy: 'https://artmuseo.com/policy'
        }
    },
    methods: {
        send(){
            if(!this.email){
                return
            }

            if(!this.fullname){
                return
            }
            const sendjoin = db.collection('beta').doc()
            sendjoin.set({email:this.email, fullname: this.fullname, userType: this.type, stat: false, serverTime: new Date(), inviteID: sendjoin.id})
            this.ifSent = true
        }
    }
}
</script>

<style scoped>
/* * {background-color: #00a89d;} */
.cpointer{
    cursor: pointer;
}

a:link {
    text-decoration: none;
}

.blank {
    width: auto;
    height: 70px;
}

@media (max-width: 800px){

        #all {
        width: 100%;
        height: auto;
        background-color: #00a89d;
        }

        #plate {
        width: 100%;
        height: 100%;
        font-family: 'cocomatpro-regular';
        /* color: white; */
        }

        #logoHolder {
        width: 90%;
        height: auto;
        margin-left: 10%;
        margin-right: auto;
        padding-top: 20px;
        /* margin-bottom: 15px; */
        position: relative;
        columns: 2;
        }

        #amCircle {
        width: 50px;
        height: 50px;
        background-position: center;
        background-repeat: no-repeat;
        }

        #amBand {
        width: 200px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        float: right;
        margin-right: 50px;
        }

        #disclaim {
        width: 100%;
        height: auto;
        margin-top: 15px;
        }

        .band {
        width: 100%;
        height: auto;
        padding-left: 10%;
        padding-right: 10%;
        padding-top: 25px;
        padding-bottom: 55px;
        background-position: right bottom;
        background-repeat: no-repeat;
        position: relative;
        overflow: auto;
        }

        .bgWhiteSmoke { background-color: whitesmoke; }
        .bgTeal { background-color: #00a89d; }
        .bgMint { background-color: #A9D9C2; }
        .bgPink { background-color: #E4A39A; }
        .bgGreen { background-color: #1F524E; }
        .bgGray { background-color: gray; }

        #footer {
        width: 100%;
        height:auto;
        background-color: gray;
        padding-left: 15%;
        padding-right: 15%;
        padding-top: 50px;
        padding-bottom: 50px;
        position: relative;
        overflow: auto;
        }


        #imgleft {
        width: 100%;
        height: 230px;
        float: left;
        clear: right;
        margin-right: 5%;
        }

        #imgright {
        width: 100%;
        height: 400px;
        float: right;
        clear: right;
        margin-left:5%;
        /* margin-top: 80px; */
        }

        #imgcenter {
        width: 50px;
        height: 100px;
        margin-left: 42%;
        background-position: center center;
        background-repeat: no-repeat;
        }

        .logobox {
        width: 100%;
        height: 100px;
        /* margin-left: 15%; */
        background-position: center;
        background-repeat: no-repeat;
        }

        .imageBox {
        height: 200px;
        background-color: transparent;
        background-position: center center;
        background-repeat: no-repeat;
        /* position: relative; */
        }

        .image-inner {
        display: block;
        height: 0;
        padding-top: 100%;
        }

        #left45 {
        width: 100%;
        height: auto;
        clear: right;
        float: left;
        }

        #right45 {
        width: 100%;
        height: auto;
        clear: right;
        float: right;
        }

        #leftholder {
        width: 100%;
        height: auto;
        float: left;
        clear: right;
        }

        #oneholder {
        width: 100%;
        height: auto;
        clear: both;
        float: left;
        }

        #centerholder {
        width: 100%;
        height: auto;
        padding-top: 10px;
        /* margin-left: 25%; */
        }

        #rightholder {
        width: 100%;
        height: auto;
        float: right;
        clear: right;
        }

        .textbox {
        width: 100%;
        height: auto;
        float: left;
        clear: right;
        font-family: "cocomatpro-light";
        font-size: 1em;
        color:white;
        line-height: 1em;
        padding: 2%;
        margin-bottom: 10px;
        background-color: transparent;
        border-style: solid;
        border-bottom-color: #00a89d;
        border-top: none;
        border-left: none;
        border-right: none;
        border-width: 2px;
        margin-top: 2%;
        margin-right: 2%;
        }

        .submitBtn {
        width: 30%;
        height: auto;
        padding: 2%;
        background: #A9D9C2;
        font-family: "cocomatpro-regular";
        font-size: 1em;
        margin-left: 35%;
        text-align: center;
        color: white;
        border-style: hidden;
        border-radius: 1vmin;
        float: left;
        clear: right;
        cursor: pointer;
        margin-top: 20px;
        }

        .submitBtn:hover {
        background: rgb(12, 194, 182);
        }


        /* FONTS & HOLDERS */
        .regtext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-regular';
        font-size: 1em;
        line-height: 1.25em;
        }

        .lighttext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: 1em;
        line-height: 1.25em;
        }

        .smalltext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: .65em;
        line-height: 1.em;
        }

        .splash {
        width: auto;
        height: auto;
        font-family: 'cocomatpro-regular';
        background-color: transparent;
        font-size: 1.5em;
        line-height: 1.25em;
        /* text-align: left; */
        position: relative;
        }

            .amWhite {
            color: white;
            }

            .amTeal {
            color: #00a89d;
            }

            .amMint {
            color: #A9D9C2;
            }

            .amGray {
            color: gray
            }

            .amSlate {
            color: slategrey;
            }

            .amGreen {
            color: #1F524E;
            }

            .amPink {
            color: #E4A39A;
            }

            .amGold {
            color: #C9B457;
            }

            .textleft {
            text-align: left;
            }

            .textright {
            text-align: right;
            }

            .textcenter {
            text-align: center;
            }
}

@media (min-width: 801px) and (max-width: 1400px){
        #all {
        width: 100%;
        height: auto;
        background-color: #00a89d;
        }
        #plate {
        width: 100%;
        height: 100vh;
        font-family: 'cocomatpro-regular';
        /* color: white; */
        }

        #logoHolder {
        width: 60%;
        height: auto;
        margin-left: 20%;
        margin-right: auto;
        padding-top: 50px;
        margin-bottom: 50px;
        position: relative;
        columns: 2;
        }

        #amCircle {
        width: 100px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        }

        #amBand {
        width: 250px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        float: right;
        }

        #disclaim {
        width: 100%;
        height: auto;
        margin-top: 15px;
        }

        .band {
        width: 100%;
        height: auto;
        padding-left: 20%;
        padding-right: 20%;
        padding-top: 25px;
        padding-bottom: 55px;
        background-position: right bottom;
        background-repeat: no-repeat;
        position: relative;
        overflow: auto;
        }

        .bgWhiteSmoke { background-color: whitesmoke; }
        .bgTeal { background-color: #00a89d; }
        .bgMint { background-color: #A9D9C2; }
        .bgPink { background-color: #E4A39A; }
        .bgGreen { background-color: #1F524E; }
        .bgGray { background-color: gray; }

        #footer {
        width: 100%;
        height:auto;
        background-color: gray;
        padding-left: 20%;
        padding-right: 20%;
        padding-top: 50px;
        padding-bottom: 50px;
        position: relative;
        overflow: auto;
        }


        #imgleft {
        width: 45%;
        height: 400px;
        float: left;
        clear: right;
        margin-right: 5%;
        }

        #imgright {
        width: 45%;
        height: 400px;
        float: right;
        clear: right;
        margin-left:5%;
        /* margin-top: 80px; */
        }

        #imgcenter {
        width: 50px;
        height: 100px;
        margin-left: 47%;
        background-position: center center;
        background-repeat: no-repeat;
        }

        .logobox {
        width: 100px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        }

        .imageBox {
        height: 400px;
        background-color: transparent;
        background-position: center center;
        background-repeat: no-repeat;
        /* position: relative; */
        }

        .image-inner {
        display: block;
        height: 0;
        padding-top: 100%;
        }

        #left45 {
        width: 45%;
        height: auto;
        clear: right;
        float: left;
        }

        #right45 {
        width: 45%;
        height: auto;
        clear: right;
        float: right;
        }

        #leftholder {
        width: 50%;
        height: auto;
        float: left;
        clear: right;
        }

        #oneholder {
        width: 100%;
        height: auto;
        clear: both;
        float: left;
        }

        #centerholder {
        width: 50%;
        height: auto;
        padding-top: 10px;
        margin-left: 25%;
        }

        #rightholder {
        width: 50%;
        height: auto;
        float: right;
        clear: right;
        }

        .textbox {
        width: 100%;
        height: auto;
        float: left;
        clear: right;
        font-family: "cocomatpro-light";
        font-size: 1em;
        color:white;
        line-height: 1em;
        padding: 2%;
        margin-bottom: 10px;
        background-color: transparent;
        border-style: solid;
        border-bottom-color: #00a89d;
        border-top: none;
        border-left: none;
        border-right: none;
        border-width: 2px;
        margin-top: 2%;
        margin-right: 2%;
        }

        .submitBtn {
        width: 30%;
        height: auto;
        padding: 2%;
        background: #A9D9C2;
        font-family: "cocomatpro-regular";
        font-size: 1em;
        margin-left: 35%;
        text-align: center;
        color: white;
        border-style: hidden;
        border-radius: 1vmin;
        float: left;
        clear: right;
        cursor: pointer;
        margin-top: 20px;
        }

        .submitBtn:hover {
        background: rgb(12, 194, 182);
        }


        /* FONTS & HOLDERS */
        .regtext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-regular';
        font-size: 1em;
        line-height: 1.25em;
        }

        .lighttext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: 1em;
        line-height: 1.25em;
        }

        .smalltext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: .65em;
        line-height: 1.em;
        }

        .splash {
        width: auto;
        height: auto;
        font-family: 'cocomatpro-regular';
        background-color: transparent;
        font-size: 1.75em;
        line-height: 2em;
        /* text-align: left; */
        position: relative;
        }
}

@media (min-width: 1401px){
        #all {
        width: 100%;
        height: auto;
        background-color: #00a89d;
        }
        #plate {
        width: 80%;
        height: auto;
        font-family: 'cocomatpro-regular';
        /* color: white; */
        margin-left: 10%;
        }

        #logoHolder {
        width: 80%;
        height: auto;
        margin-left: 10%;
        margin-right: auto;
        padding-top: 50px;
        margin-bottom: 50px;
        position: relative;
        columns: 2;
        }

        #amCircle {
        width: 100px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        }

        #amBand {
        width: 250px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        float: right;
        }

        #disclaim {
        width: 100%;
        height: auto;
        margin-top: 15px;
        text-align: left;
        }

        .band {
        width: 100%;
        height: auto;
        padding-left: 10%;
        padding-right: 10%;
        padding-top: 25px;
        padding-bottom: 55px;
        background-position: right bottom;
        background-repeat: no-repeat;
        position: relative;
        overflow: auto;
        }

        .bgWhiteSmoke { background-color: whitesmoke; }
        .bgTeal { background-color: #00a89d; }
        .bgMint { background-color: #A9D9C2; }
        .bgPink { background-color: #E4A39A; }
        .bgGreen { background-color: #1F524E; }
        .bgGray { background-color: gray; }

        #footer {
        width: 100%;
        height:auto;
        background-color: gray;
        padding-left: 10%;
        padding-right: 10%;
        padding-top: 50px;
        padding-bottom: 50px;
        position: relative;
        overflow: auto;
        }


        #imgleft {
        width: 45%;
        height: 400px;
        float: left;
        clear: right;
        margin-right: 5%;
        }

        #imgright {
        width: 45%;
        height: 400px;
        float: right;
        clear: right;
        margin-left:5%;
        /* margin-top: 80px; */
        }

        #imgcenter {
        width: 50px;
        height: 100px;
        margin-left: 47%;
        background-position: center center;
        background-repeat: no-repeat;
        }

        .logobox {
        width: 100px;
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        }

        .imageBox {
        height: 400px;
        background-color: transparent;
        background-position: center center;
        background-repeat: no-repeat;
        /* position: relative; */
        }

        .image-inner {
        display: block;
        height: 0;
        padding-top: 100%;
        }

        #left45 {
        width: 45%;
        height: auto;
        clear: right;
        float: left;
        }

        #right45 {
        width: 45%;
        height: auto;
        clear: right;
        float: right;
        }

        #leftholder {
        width: 50%;
        height: auto;
        float: left;
        clear: right;
        }

        #oneholder {
        width: 100%;
        height: auto;
        clear: both;
        float: left;
        }

        #centerholder {
        width: 50%;
        height: auto;
        padding-top: 10px;
        margin-left: 25%;
        }

        #rightholder {
        width: 50%;
        height: auto;
        float: right;
        clear: right;
        }

        .textbox {
        width: 100%;
        height: auto;
        float: left;
        clear: right;
        font-family: "cocomatpro-light";
        font-size: 1em;
        color:white;
        line-height: 1em;
        padding: 2%;
        margin-bottom: 10px;
        background-color: transparent;
        border-style: solid;
        border-bottom-color: #00a89d;
        border-top: none;
        border-left: none;
        border-right: none;
        border-width: 2px;
        margin-top: 2%;
        margin-right: 2%;
        }

        .submitBtn {
        width: 30%;
        height: auto;
        padding: 2%;
        background: #A9D9C2;
        font-family: "cocomatpro-regular";
        font-size: 1em;
        margin-left: 35%;
        text-align: center;
        color: white;
        border-style: hidden;
        border-radius: 1vmin;
        float: left;
        clear: right;
        cursor: pointer;
        margin-top: 20px;
        }

        .submitBtn:hover {
        background: rgb(12, 194, 182);
        }


        /* FONTS & HOLDERS */
        .regtext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-regular';
        font-size: 1.15em;
        line-height: 1.35em;
        }

        .lighttext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: 1.15em;
        line-height: 1.35em;
        }

        .smalltext {
        background: transparent;
        height: auto;
        font-family: 'cocomatpro-light';
        font-size: .65em;
        line-height: 1.em;
        }

        .splash {
        width: auto;
        height: auto;
        font-family: 'cocomatpro-regular';
        background-color: transparent;
        font-size: 1.95em;
        line-height: 2em;
        /* text-align: left; */
        position: relative;
        }
}

.amWhite {
    color: white;
}

.amTeal {
    color: #00a89d;
}

.amMint {
    color: #A9D9C2;
}

.amGray {
    color: gray
}

.amSlate {
    color: slategrey;
}

.amGreen {
    color: #1F524E;
}

.amPink {
    color: #E4A39A;
}

.amGold {
    color: #C9B457;
}

.textleft {
    text-align: left;
}

.textright {
    text-align: right;
}

.textcenter {
    text-align: center;
}

</style>